import { Field } from 'devextreme/ui/pivot_grid/data_source';

export const value_4: Field = {
  dataField: 'value_4',
  dataType: 'number',
  summaryType: 'sum',
  isMeasure: true,
  format: {
    type: 'fixedPoint',
  },
};

export const value_4_precision: Field = {
  ...value_4,
  format: {
    type: 'fixedPoint',
    precision: 3,
  },
};

export const value_4_data: Field = {
  ...value_4,
  area: 'data',
};

export const value_4_data_precision: Field = {
  ...value_4_data,
  format: {
    type: 'fixedPoint',
    precision: 3,
  },
};

export const value_4_no_year_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return e.field('row') && e.field('row').name === 'year' ? undefined : e.value(false);
  },
};

export const value_4_no_year_half_year_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return (e.field('row') && e.field('row').name === 'year') || (e.field('row') && e.field('row').name === 'halfYear')
      ? undefined
      : e.value(false);
  },
};

export const value_4_no_year_month_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return (e.field('row') && e.field('row').name === 'year') || (e.field('row') && e.field('row').name === 'month') ? undefined : e.value(false);
  },
};

export const ertek_value_4: Field = {
  ...value_4,
  caption: 'ertek',
};

export const ertek_value_4_data: Field = {
  ...value_4_data,
  caption: 'ertek',
};

export const ertek_value_4_no_year_summary: Field = {
  ...ertek_value_4,
  ...value_4_no_year_summary,
};

export const ertek_value_4_no_year_month_summary: Field = {
  ...ertek_value_4,
  ...value_4_no_year_month_summary,
};

export const ertek_value_4_data_no_year_summary: Field = {
  ...ertek_value_4_data,
  ...value_4_no_year_summary,
};

export const ertek_value_4_data_no_year_month_summary: Field = {
  ...ertek_value_4_data,
  ...value_4_no_year_month_summary,
};

export const terajoule_value_4: Field = {
  ...value_4,
  caption: 'Terajoule',
};

export const terajoule_value_4_data: Field = {
  ...value_4_data,
  caption: 'Terajoule',
};

export const terajoule_value_4_data_precision: Field = {
  ...value_4_data_precision,
  caption: 'Terajoule',
};

export const terajoule_value_4_no_year_summary: Field = {
  ...terajoule_value_4,
  ...value_4_no_year_summary,
};

export const terajoule_value_4_no_year_month_summary: Field = {
  ...terajoule_value_4,
  ...value_4_no_year_month_summary,
};

export const terajoule_value_4_data_no_year_summary: Field = {
  ...terajoule_value_4_data,
  ...value_4_no_year_summary,
};

export const terajoule_value_4_data_no_year_month_summary: Field = {
  ...terajoule_value_4_data,
  ...value_4_no_year_month_summary,
};

export const terajoule_brutto_value_4: Field = {
  ...value_4,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_4_precision: Field = {
  ...value_4_precision,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_4_data: Field = {
  ...value_4_data,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_4_no_year_summary: Field = {
  ...terajoule_brutto_value_4,
  ...value_4_no_year_summary,
};

export const terajoule_brutto_value_4_no_year_month_summary: Field = {
  ...terajoule_brutto_value_4,
  ...value_4_no_year_month_summary,
};

export const terajoule_brutto_value_4_data_no_year_summary: Field = {
  ...terajoule_brutto_value_4_data,
  ...value_4_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_4_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_4,
  ...value_4_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_4_precision_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_4_precision,
  ...value_4_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_4_data_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_4_data,
  ...value_4_no_year_half_year_summary,
};

export const terajoule_brutto_value_4_data_no_year_month_summary: Field = {
  ...terajoule_brutto_value_4_data,
  ...value_4_no_year_month_summary,
};

export const terajoule_netto_value_4: Field = {
  ...value_4,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_4_precision: Field = {
  ...value_4_precision,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_4_data: Field = {
  ...value_4_data,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_4_no_year_summary: Field = {
  ...terajoule_netto_value_4,
  ...value_4_no_year_summary,
};

export const terajoule_netto_value_4_no_year_month_summary: Field = {
  ...terajoule_netto_value_4,
  ...value_4_no_year_month_summary,
};

export const terajoule_netto_value_4_data_no_year_summary: Field = {
  ...terajoule_netto_value_4_data,
  ...value_4_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_4_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_4,
  ...value_4_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_4_precision_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_4_precision,
  ...value_4_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_4_data_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_4_data,
  ...value_4_no_year_half_year_summary,
};

export const terajoule_netto_value_4_data_no_year_month_summary: Field = {
  ...terajoule_netto_value_4_data,
  ...value_4_no_year_month_summary,
};

export const ezer_tonna_value_4: Field = {
  ...value_4,
  caption: 'ezer_tonna',
};

export const ezer_tonna_value_4_data: Field = {
  ...value_4_data,
  caption: 'ezer_tonna',
};

export const ezer_tonna_value_4_data_precision: Field = {
  ...value_4_data_precision,
  caption: 'ezer_tonna',
};

export const ezer_tonna_value_4_no_year_summary: Field = {
  ...ezer_tonna_value_4,
  ...value_4_no_year_summary,
};

export const ezer_tonna_value_4_no_year_month_summary: Field = {
  ...ezer_tonna_value_4,
  ...value_4_no_year_month_summary,
};

export const ezer_tonna_value_4_data_no_year_summary: Field = {
  ...ezer_tonna_value_4_data,
  ...value_4_no_year_summary,
};

export const ezer_tonna_value_4_data_no_year_month_summary: Field = {
  ...ezer_tonna_value_4_data,
  ...value_4_no_year_month_summary,
};

export const kilo_tonna_value_4: Field = {
  ...value_4,
  caption: 'kilo_tonna',
};

export const kilo_tonna_value_4_data: Field = {
  ...value_4_data,
  caption: 'kilo_tonna',
};

export const kilo_tonna_value_4_no_year_summary: Field = {
  ...kilo_tonna_value_4,
  ...value_4_no_year_summary,
};

export const kilo_tonna_value_4_no_year_month_summary: Field = {
  ...kilo_tonna_value_4,
  ...value_4_no_year_month_summary,
};

export const kilo_tonna_value_4_data_no_year_summary: Field = {
  ...kilo_tonna_value_4_data,
  ...value_4_no_year_summary,
};

export const kilo_tonna_value_4_data_no_year_month_summary: Field = {
  ...kilo_tonna_value_4_data,
  ...value_4_no_year_month_summary,
};

export const ezer_kobmeter_value_4: Field = {
  ...value_4,
  caption: 'ezer_kobmeter',
};

export const ezer_kobmeter_value_4_data: Field = {
  ...value_4_data,
  caption: 'ezer_kobmeter',
};

export const ezer_kobmeter_value_4_no_year_summary: Field = {
  ...ezer_kobmeter_value_4,
  ...value_4_no_year_summary,
};

export const ezer_kobmeter_value_4_no_year_month_summary: Field = {
  ...ezer_kobmeter_value_4,
  ...value_4_no_year_month_summary,
};

export const ezer_kobmeter_value_4_data_no_year_summary: Field = {
  ...ezer_kobmeter_value_4_data,
  ...value_4_no_year_summary,
};

export const ezer_kobmeter_value_4_data_no_year_month_summary: Field = {
  ...ezer_kobmeter_value_4_data,
  ...value_4_no_year_month_summary,
};

export const millio_kobmeter_value_4: Field = {
  ...value_4,
  caption: 'Mm3',
};

export const millio_kobmeter_value_4_data: Field = {
  ...value_4_data,
  caption: 'Mm3',
};

export const millio_kobmeter_value_4_data_precision: Field = {
  ...value_4_data_precision,
  caption: 'Mm3',
};

export const millio_kobmeter_value_4_no_year_summary: Field = {
  ...millio_kobmeter_value_4,
  ...value_4_no_year_summary,
};

export const millio_kobmeter_value_4_no_year_month_summary: Field = {
  ...millio_kobmeter_value_4,
  ...value_4_no_year_month_summary,
};

export const millio_kobmeter_value_4_data_no_year_summary: Field = {
  ...millio_kobmeter_value_4_data,
  ...value_4_no_year_summary,
};

export const millio_kobmeter_value_4_data_no_year_month_summary: Field = {
  ...millio_kobmeter_value_4_data,
  ...value_4_no_year_month_summary,
};

export const kilowatt_value_4_data: Field = {
  ...value_4_data,
  caption: 'kW',
};

export const kilowatt_value_4_data_no_year_summary: Field = {
  ...kilowatt_value_4_data,
  ...value_4_no_year_summary,
};

export const megawatt_value_4: Field = {
  ...value_4,
  caption: 'MW',
};

export const megawatt_value_4_data: Field = {
  ...value_4_data,
  caption: 'MW',
};

export const kilowatt_ora_value_4: Field = {
  ...value_4,
  caption: 'kWh',
};

export const megawatt_value_4_max: Field = {
  ...megawatt_value_4,
  summaryType: 'max',
};

export const megawatt_value_4_data_max: Field = {
  ...megawatt_value_4_data,
  summaryType: 'max',
};

export const kilowatt_ora_value_4_data: Field = {
  ...value_4_data,
  caption: 'kWh',
};

export const kilowatt_ora_value_4_no_year_summary: Field = {
  ...kilowatt_ora_value_4,
  ...value_4_no_year_summary,
};

export const kilowatt_ora_value_4_no_year_month_summary: Field = {
  ...kilowatt_ora_value_4,
  ...value_4_no_year_month_summary,
};

export const kilowatt_ora_value_4_data_no_year_summary: Field = {
  ...kilowatt_ora_value_4_data,
  ...value_4_no_year_summary,
};

export const kilowatt_ora_value_4_data_no_year_month_summary: Field = {
  ...kilowatt_ora_value_4_data,
  ...value_4_no_year_month_summary,
};

export const megawatt_ora_value_4: Field = {
  ...value_4,
  caption: 'MWh',
};

export const megawatt_ora_value_4_data: Field = {
  ...value_4_data,
  caption: 'MWh',
};

export const megawatt_ora_value_4_no_year_summary: Field = {
  ...megawatt_ora_value_4,
  ...value_4_no_year_summary,
};

export const megawatt_ora_value_4_no_year_month_summary: Field = {
  ...megawatt_ora_value_4,
  ...value_4_no_year_month_summary,
};

export const megawatt_ora_value_4_data_no_year_summary: Field = {
  ...megawatt_ora_value_4_data,
  ...value_4_no_year_summary,
};

export const megawatt_ora_value_4_data_no_year_month_summary: Field = {
  ...megawatt_ora_value_4_data,
  ...value_4_no_year_month_summary,
};

export const gigawatt_ora_value_4: Field = {
  ...value_4,
  caption: 'gigawatt_ora',
};

export const gigawatt_ora_value_4_data: Field = {
  ...value_4_data,
  caption: 'gigawatt_ora',
};

export const gigawatt_ora_value_4_data_precision: Field = {
  ...value_4_data_precision,
  caption: 'gigawatt_ora',
};

export const gigawatt_ora_value_4_no_year_summary: Field = {
  ...gigawatt_ora_value_4,
  ...value_4_no_year_summary,
};

export const gigawatt_ora_value_4_no_year_month_summary: Field = {
  ...gigawatt_ora_value_4,
  ...value_4_no_year_month_summary,
};

export const gigawatt_ora_value_4_data_no_year_summary: Field = {
  ...gigawatt_ora_value_4_data,
  ...value_4_no_year_summary,
};

export const gigawatt_ora_value_4_data_no_year_month_summary: Field = {
  ...gigawatt_ora_value_4_data,
  ...value_4_no_year_month_summary,
};

export const forint_value_4: Field = {
  ...value_4,
  caption: 'ezer_forint',
};

export const forint_value_4_data: Field = {
  ...value_4_data,
  caption: 'ezer_forint',
};

export const forint_value_4_no_year_summary: Field = {
  ...forint_value_4,
  ...value_4_no_year_summary,
};

export const forint_value_4_no_year_month_summary: Field = {
  ...forint_value_4,
  ...value_4_no_year_month_summary,
};

export const forint_value_4_data_no_year_summary: Field = {
  ...forint_value_4_data,
  ...value_4_no_year_summary,
};

export const forint_value_4_data_no_year_month_summary: Field = {
  ...forint_value_4_data,
  ...value_4_no_year_month_summary,
};

export const petajoule_value_4: Field = {
  ...value_4,
  caption: 'Petajoule',
};

export const petajoule_value_4_data: Field = {
  ...value_4_data,
  caption: 'Petajoule',
};

export const petajoule_value_4_no_year_summary: Field = {
  ...petajoule_value_4,
  ...value_4_no_year_summary,
};

export const petajoule_value_4_no_year_month_summary: Field = {
  ...petajoule_value_4,
  ...value_4_no_year_month_summary,
};

export const petajoule_value_4_data_no_year_summary: Field = {
  ...petajoule_value_4_data,
  ...value_4_no_year_summary,
};

export const petajoule_value_4_data_no_year_month_summary: Field = {
  ...petajoule_value_4_data,
  ...value_4_no_year_month_summary,
};

export const szazalek_value_4: Field = {
  ...value_4,
  caption: 'szazalek',
};

export const szazalek_value_4_data: Field = {
  ...value_4_data,
  caption: 'szazalek',
};

export const szazalek_value_4_no_year_summary: Field = {
  ...szazalek_value_4,
  ...value_4_no_year_summary,
};

export const szazalek_value_4_no_year_month_summary: Field = {
  ...szazalek_value_4,
  ...value_4_no_year_month_summary,
};

export const szazalek_value_4_data_no_year_summary: Field = {
  ...szazalek_value_4_data,
  ...value_4_no_year_summary,
};

export const szazalek_value_4_data_no_year_month_summary: Field = {
  ...szazalek_value_4_data,
  ...value_4_no_year_month_summary,
};

export const huf_kilowatt_ora_value_4: Field = {
  ...value_4,
  caption: 'huf_kilowatt_ora',
};

export const huf_kilowatt_ora_value_4_data: Field = {
  ...value_4_data,
  caption: 'huf_kilowatt_ora',
};

export const huf_kilowatt_ora_value_4_no_year_summary: Field = {
  ...huf_kilowatt_ora_value_4,
  ...value_4_no_year_summary,
};

export const huf_kilowatt_ora_value_4_no_year_month_summary: Field = {
  ...huf_kilowatt_ora_value_4,
  ...value_4_no_year_month_summary,
};

export const huf_kilowatt_ora_value_4_data_no_year_summary: Field = {
  ...huf_kilowatt_ora_value_4_data,
  ...value_4_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_kilowatt_ora_value_4_data_no_year_half_year_summary: Field = {
  ...huf_kilowatt_ora_value_4_data,
  ...value_4_no_year_half_year_summary,
};

export const huf_kilowatt_ora_value_4_data_no_year_month_summary: Field = {
  ...huf_kilowatt_ora_value_4_data,
  ...value_4_no_year_month_summary,
};

export const huf_gigajoule_brutto_value_4: Field = {
  ...value_4,
  caption: 'huf_gigajoule_brutto',
};

export const huf_gigajoule_brutto_value_4_precision: Field = {
  ...value_4_precision,
  caption: 'huf_gigajoule_brutto',
};

export const huf_gigajoule_brutto_value_4_data: Field = {
  ...value_4_data,
  caption: 'huf_gigajoule_brutto',
};

export const huf_gigajoule_brutto_value_4_no_year_summary: Field = {
  ...huf_gigajoule_brutto_value_4,
  ...value_4_no_year_summary,
};

export const huf_gigajoule_brutto_value_4_no_year_month_summary: Field = {
  ...huf_gigajoule_brutto_value_4,
  ...value_4_no_year_month_summary,
};

export const huf_gigajoule_brutto_value_4_data_no_year_summary: Field = {
  ...huf_gigajoule_brutto_value_4_data,
  ...value_4_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_brutto_value_4_no_year_half_year_summary: Field = {
  ...huf_gigajoule_brutto_value_4,
  ...value_4_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_brutto_value_4_precision_no_year_half_year_summary: Field = {
  ...huf_gigajoule_brutto_value_4_precision,
  ...value_4_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_brutto_value_4_data_no_year_half_year_summary: Field = {
  ...huf_gigajoule_brutto_value_4_data,
  ...value_4_no_year_half_year_summary,
};

export const huf_gigajoule_brutto_value_4_data_no_year_month_summary: Field = {
  ...huf_gigajoule_brutto_value_4_data,
  ...value_4_no_year_month_summary,
};

export const huf_gigajoule_netto_value_4: Field = {
  ...value_4,
  caption: 'huf_gigajoule_netto',
};

export const huf_gigajoule_netto_value_4_precision: Field = {
  ...value_4_precision,
  caption: 'huf_gigajoule_netto',
};

export const huf_gigajoule_netto_value_4_data: Field = {
  ...value_4_data,
  caption: 'huf_gigajoule_netto',
};

export const huf_gigajoule_netto_value_4_no_year_summary: Field = {
  ...huf_gigajoule_netto_value_4,
  ...value_4_no_year_summary,
};

export const huf_gigajoule_netto_value_4_no_year_month_summary: Field = {
  ...huf_gigajoule_netto_value_4,
  ...value_4_no_year_month_summary,
};

export const huf_gigajoule_netto_value_4_data_no_year_summary: Field = {
  ...huf_gigajoule_netto_value_4_data,
  ...value_4_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_netto_value_4_no_year_half_year_summary: Field = {
  ...huf_gigajoule_netto_value_4,
  ...value_4_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_netto_value_4_precision_no_year_half_year_summary: Field = {
  ...huf_gigajoule_netto_value_4_precision,
  ...value_4_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_netto_value_4_data_no_year_half_year_summary: Field = {
  ...huf_gigajoule_netto_value_4_data,
  ...value_4_no_year_half_year_summary,
};

export const huf_gigajoule_netto_value_4_data_no_year_month_summary: Field = {
  ...huf_gigajoule_netto_value_4_data,
  ...value_4_no_year_month_summary,
};
